
import './Teenused.css';
import {useState, useEffect} from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';

import { Button, Navbar, Container, Nav, NavDropdown, Card, Row, Col, Image, Table, ThemeProvider } from 'react-bootstrap';

export default function Hero() {

    return (
      <div className='main'>
        <Container>

        
          <Container style={{marginBottom:"2.5rem", fontWeight:"500", textAlign:"start", color:"#43ACE7",}}>
           <h1 style={{color:"#43ACE7", textAlign:"center"}}>
            <strong >Teens, Ortodontia</strong>
          </h1>
            <p style={{color:"#43ACE7", fontWeight:"500", textAlign:"start"}}></p>
                        <div style={{display:"flow"}}>
              <div style={{float:"right", display:"flex", flexDirection:"column"}}>
                <div className='ortodontia-t-photo' ></div>
                Foto: theclearguard
              </div>
              
              <h2>
                Teens ortodontia
              </h2>
              <p>
                 Teismeeas saab hambumust efektiivselt korrigeerida, parandades nii naeratuse välimust kui ka enesekindlust.
Puuduvad või ebatavalise nurga all olevad hambad võivad noort muuta ebakindlaks – ortodontiline ravi aitab luua ühtlase ja loomuliku naeratuse.
              </p>
              Eelised noorele:
              <ul>
                <li>
                  Enesekindlus – sirgem naeratus ja parem esteetika
                </li>
                <li>
                  Funktsioon – parem närimine ja kõne
                </li>
                <li>
                  Tervis – lihtsam suuhügieen, väiksem kaariese ja igemepõletiku risk
                </li>
                <li>
                  Kasvupotentsiaal – lõualuude arengut saab veel suunata
                </li>
              </ul>

              Ravivõimalused:
              <ul>
                <li>
                  Breketid – metall- või keraamilised breketid täpseks hammaste liigutamiseks
                </li>
                <li>
                  Alignerid – läbipaistvad kaped, nt Invisalign Teen, mis on diskreetsed ja mugavad
                </li>
                <li>
                  Puuduvate esihammaste ajutine asendamine – esteetilised lahendused ravi ajal (nt ajutised hambad või kapedesse integreeritud asendused)
                </li>
                <li>
                  Eriliste hambaasendite korrigeerimine – pöördunud, kinni jäänud või vale nurga all olevate hammaste suunamine õigesse asendisse
                </li>
              </ul>
              <p>
                Õigeaegne ortodontiline ravi aitab noorel tunda end oma naeratusega kindlalt nii igapäevaelus kui ka sotsiaalsetes olukordades.
              </p>
            </div>

      </Container>
          </Container>

        </div>
    );
}